import { render, staticRenderFns } from "./TabCustomize.vue?vue&type=template&id=54f78902&scoped=true&"
import script from "./TabCustomize.vue?vue&type=script&lang=js&"
export * from "./TabCustomize.vue?vue&type=script&lang=js&"
import style0 from "./TabCustomize.vue?vue&type=style&index=0&id=54f78902&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f78902",
  null
  
)

export default component.exports